import { useLocation, useHistory } from 'react-router-dom';
import { useCallback } from 'react';
import encodeBase64, { decodeBase64 } from '../utils/encodeBase64';

export function useSearchParams({ base64 = false } = {}) {
    const location = useLocation();
    const history = useHistory();

    // Función para leer un param
    const getSearchParam = useCallback(
        key => {
            const params = new URLSearchParams(location.search);
            const value = params.get(key);
            if (value && base64) return decodeBase64(value);
            return value;
        },
        [location.search, base64]
    );

    // Función para actualizar un param
    const setSearchParam = useCallback(
        (key, value) => {
            const params = new URLSearchParams(location.search);
            params.set(key, base64 ? encodeBase64(value) : value);
            history.push({ search: params.toString() });
        },
        [location.search, history, base64]
    );

    // Función para eliminar un param
    const removeSearchParam = useCallback(
        key => {
            const params = new URLSearchParams(location.search);
            params.delete(key);
            history.push({ search: params.toString() });
        },
        [location.search, history]
    );

    return { getSearchParam, setSearchParam, removeSearchParam };
}
